import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

// SemanticUI components
import { Card, Icon, Image, Grid, GridColumn } from 'semantic-ui-react';



/**
 * 
 * @param {string} uploadUrl 
 * @returns 
 */
const DragDropUploader = ({ uploadUrl }) => {
  // local state
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);



  /**
   * 
   * @param {array} files 
   * @async
   */
  const handleUpload = useCallback(async (files) => {
    setUploading(true);
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    try {
      const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      const result = await response.json();
      console.log('Upload successful:', result);
    } catch (error) {
      console.error('Error uploading files:', error);
    } finally {
      setUploading(false);
    }
  }, [uploadUrl]);

  /**
   * @param {string} acceptedFiles
   * @callback
   */
  const onDrop = useCallback((acceptedFiles) => {
    setFiles(acceptedFiles);
    handleUpload(acceptedFiles);
  }, [handleUpload]);

  // Init dropzone
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps()} className="dropzone">
      <input {...getInputProps()} />
      <Card fluid raised>
        <Card.Content textAlign="center">
          <Icon name="cloud upload" size="huge" />
          <p>Drag & Drop your images here, or click to select files</p>
        </Card.Content>
      </Card>
      {uploading && <p>Uploading...</p>}
      <Grid columns={4}>
        {files.map((file, index) => (
          <GridColumn key={index}>
            <Image src={URL.createObjectURL(file)} size="small" />
          </GridColumn>
        ))}
      </Grid>
    </div>
  );
};

export default DragDropUploader;
